import React, { useEffect } from "react";
import { InputSelect } from "./FormElements/InputSelect";
import { InputField } from "./FormElements/InputField";
import { BaseType, CurrencyType } from "../types/formRVEO";
import Button from "./FormElements/Button";
import { BaseModal } from "./FormElements/BaseModal";
import { MODALITIES } from "../Utils/constants";

interface IModalitiesForm {
  modData: any;
  register: any;
  modalitiesSelect: any;
  currency: BaseType<CurrencyType>[];
  deferredYears: any;
  guaranteedYears: any;
  tempYears: any;
  errors: any;
  open: boolean;
  close: any;
  disableSend?: boolean;
  onSubmit: (modalitie: any) => void;
  upgrade?: boolean;
  title: string;
  selectedModalitie?: any;
  setValueModalitie?: any;
}

export const ModalitiesForm = ({
  modData,
  register,
  modalitiesSelect,
  currency,
  errors,
  close,
  deferredYears,
  tempYears,
  guaranteedYears,
  open,
  disableSend,
  onSubmit,
  upgrade,
  title,
  selectedModalitie,
  setValueModalitie,
}: IModalitiesForm) => {
  useEffect(() => {
    if (selectedModalitie && setValueModalitie) {
      setValueModalitie("modalities", selectedModalitie.modalities);
      setValueModalitie("currencyMod", selectedModalitie.currencyMod);
      setValueModalitie("defYearsMod", selectedModalitie.defYearsMod);
      setValueModalitie("tempYearsMod", selectedModalitie.tempYearsMod);
      setValueModalitie("guarYearsMod", selectedModalitie.guarYearsMod);
    }
  }, [selectedModalitie, setValueModalitie]);

  return (
    <BaseModal open={open} handleClose={close} title={title} prov={true}>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          maxHeight: "630px",
        }}
        onSubmit={onSubmit}
      >
        {!upgrade && (
          <>
            {" "}
            <InputSelect
              options={modData}
              register={register}
              name="modalities"
              placeHolder="Modalidades"
            />
            <InputSelect
              options={currency}
              register={register}
              placeHolder="Moneda"
              disabled={!modalitiesSelect}
              name="currencyMod"
            />
            <InputSelect
              options={deferredYears}
              register={register}
              placeHolder={`Años Diferidos`}
              disabled={modalitiesSelect !== MODALITIES.RENTA_TEMPORAL_VITALICIA_DIFERIDA}
              name="defYearsMod"
            />
            <InputSelect
              options={guaranteedYears}
              register={register}
              placeHolder={`Años Garantizados`}
              disabled={!modalitiesSelect}
              name="guarYearsMod"
            />
          </>
        )}

        {upgrade && (
          <>
            <InputField placeHolder={"Comisión"} />
            <InputField placeHolder={"TIR"} />
          </>
        )}
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "12px" }}
        >
          <div style={{ width: "50%" }}>
            <Button type="submit" disabled={disableSend}>
              {"Aceptar"}
            </Button>
          </div>
        </div>
      </form>
    </BaseModal>
  );
};
